import { Component, OnInit } from '@angular/core';
import { UserLoginService } from '../service/cognito.service';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  invalidResetPasswordMsg: string;
  resetpassword: any = {};
  loaderActivate: boolean;

  constructor(private authService: AuthService, private router: Router,
    public userService: UserLoginService, private translate: TranslateService) { }

  ngOnInit() {
  }

  onFormSubmit(model: any, isValid: boolean) {
    if (!isValid) {
      // this.invalidResetPasswordMsg = 'All fields are required';
      this.translate.get('Register.Allfieldsrequired').subscribe(error => {
        this.invalidResetPasswordMsg = error;
      });
      return;
    }
    this.invalidResetPasswordMsg = null;
    this.loaderActivate = true;
     this.userService.confirmNewPassword(model.username, model.verificationcode, model.password, this);
  }
  cognitoCallback(message: string, result: any) {
    if (message != null) { // error
      this.invalidResetPasswordMsg = message;
      if (message === 'Invalid verification code provided, please try again.') {
        this.translate.get('ForgotPassword.InvalidVerificationcode').subscribe(error => {
          this.invalidResetPasswordMsg = error;
        });
      }

      if (message === 'Password does not conform to policy: Password not long enough') {
        this.translate.get('Register.InvalidPassword').subscribe(error => {
          this.invalidResetPasswordMsg = error;
        });
      }
      this.loaderActivate = false;
    } else { // success
      this.router.navigate(['/login']);
      this.loaderActivate = false;
    }
  }
  // Go to Login
  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/reset-password/reset-password.component.ts